import React, { useState, Fragment } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import './navbar.css'

const Navbar = () => {
  const { t, i18n } = useTranslation()
  const [link5AccordionOpen, setLink5AccordionOpen] = useState(false)
  const [link5DropdownVisible, setLink5DropdownVisible] = useState(false)

  const onLangChange = (e) => {
    i18n.changeLanguage(e.target.value)
  }

  return (
    <header className="navbar8-container1">
      <header data-thq="thq-navbar" className="navbar8-navbar-interactive">
        <div data-thq="thq-navbar-nav" className="navbar8-desktop-menu">
          <nav className="navbar8-links1">
            <select
              aria-label={t('navbar.language')}
              value={i18n.language?.slice(0,2) || 'en'}
              onChange={onLangChange}
              className="thq-body-small"
              style={{ 
                padding: '8px 12px', 
                borderRadius: 8,
                border: '1px solid #ddd',
                backgroundColor: 'white',
                cursor: 'pointer'
              }}
            >
              <option value="fr">🇫🇷 FR</option>
              <option value="nl">🇳🇱 NL</option>
              <option value="en">🇬🇧 EN</option>
              <option value="de">🇩🇪 DE</option>
            </select>
          </nav>
          <div className="navbar8-buttons1">
            <Link to="/booking">
              <button className="navbar8-action11 thq-button-animated thq-button-filled">
                <span className="navbar8-text22">{t('common.bookNow')}</span>
              </button>
            </Link>
            <button className="navbar8-action21 thq-button-outline thq-button-animated">
              <span className="navbar8-text25">{t('common.contactUs')}</span>
            </button>
          </div>
        </div>
        <div data-thq="thq-burger-menu" className="navbar8-burger-menu">
          <svg viewBox="0 0 1024 1024" className="navbar8-icon14">
            <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
          </svg>
        </div>
        <div data-thq="thq-mobile-menu" className="navbar8-mobile-menu">
          <div className="navbar8-nav">
            <div className="navbar8-top">
              <select
                aria-label={t('navbar.language')}
                value={i18n.language?.slice(0,2) || 'en'}
                onChange={onLangChange}
                className="thq-body-small"
                style={{ 
                  padding: '6px 8px', 
                  borderRadius: 6,
                  border: '1px solid #ddd',
                  backgroundColor: 'white',
                  cursor: 'pointer',
                  marginRight: '8px'
                }}
              >
                <option value="fr">🇫🇷 FR</option>
                <option value="nl">🇳🇱 NL</option>
                <option value="en">🇬🇧 EN</option>
                <option value="de">🇩🇪 DE</option>
              </select>
              <img
                alt={t('navbar.logoAlt')}
                src="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/84ec08e8-34e9-42c7-9445-d2806d156403/fac575ac-7a41-484f-b7ac-875042de11f8?org_if_sml=1&force_format=original"
                className="navbar8-logo"
              />
              <div data-thq="thq-close-menu" className="navbar8-close-menu">
                <svg viewBox="0 0 1024 1024" className="navbar8-icon16">
                  <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                </svg>
              </div>
            </div>
            <nav className="navbar8-links2">
              <a
                href="https://www.teleporthq.io"
                className="navbar8-link12 thq-body-small thq-link"
              >
                {t('navbar.homeHash')}
              </a>
              <a href="https://www.teleporthq.io" className="thq-body-small thq-link">
                {t('navbar.aboutHash')}
              </a>
              <a
                href="https://www.teleporthq.io"
                className="navbar8-link32 thq-body-small thq-link"
              >
                {t('navbar.locationHash')}
              </a>
              <div className="navbar8-link4-accordion">
                <div
                  onClick={() => setLink5AccordionOpen(!link5AccordionOpen)}
                  className="navbar8-trigger"
                >
                  <span className="thq-body-small thq-link">
                    {t('navbar.contactHash')}
                  </span>
                  <div className="navbar8-icon-container2">
                    {link5AccordionOpen === true && (
                      <div className="navbar8-container4">
                        <svg viewBox="0 0 1024 1024" className="navbar8-icon18">
                          <path d="M298 426h428l-214 214z"></path>
                        </svg>
                      </div>
                    )}
                    {link5AccordionOpen === false && (
                      <div className="navbar8-container5">
                        <svg viewBox="0 0 1024 1024" className="navbar8-icon20">
                          <path d="M426 726v-428l214 214z"></path>
                        </svg>
                      </div>
                    )}
                  </div>
                </div>
                {link5AccordionOpen === true && (
                  <div className="navbar8-container6">
                    <a href="https://www.teleporthq.io">
                      <div className="navbar8-menu-item1">
                        <img
                          alt={t('navbar.dropdown.alt1')}
                          src="https://images.unsplash.com/photo-1611675822385-ef5f3fd290d7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1NDIwMjk3N3w&ixlib=rb-4.1.0&q=80&w=1080"
                          className="navbar8-page1-image1"
                        />
                        <div className="navbar8-content1">
                          <span className="navbar8-page11 thq-body-large">
                            {t('navbar.dropdown.home')}
                          </span>
                          <span className="thq-body-small">
                            {t('navbar.dropdown.homeDesc')}
                          </span>
                        </div>
                      </div>
                    </a>
                    <a href="https://www.teleporthq.io">
                      <div className="navbar8-menu-item2">
                        <img
                          alt={t('navbar.dropdown.alt2')}
                          src="https://images.unsplash.com/photo-1586093698343-7941a6cfe354?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1NDIwMjk3N3w&ixlib=rb-4.1.0&q=80&w=1080"
                          className="navbar8-page2-image1"
                        />
                        <div className="navbar8-content2">
                          <span className="navbar8-page21 thq-body-large">
                            {t('navbar.dropdown.about')}
                          </span>
                          <span className="thq-body-small">
                            {t('navbar.dropdown.aboutDesc')}
                          </span>
                        </div>
                      </div>
                    </a>
                    <a href="https://www.teleporthq.io">
                      <div className="navbar8-menu-item3">
                        <img
                          alt={t('navbar.dropdown.alt3')}
                          src="https://images.unsplash.com/photo-1487148742994-2f29d489182f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1NDIwMjk3OHw&ixlib=rb-4.1.0&q=80&w=1080"
                          className="navbar8-page3-image1"
                        />
                        <div className="navbar8-content3">
                          <span className="navbar8-page31 thq-body-large">
                            {t('navbar.dropdown.location')}
                          </span>
                          <span className="thq-body-small">
                            {t('navbar.dropdown.locationDesc')}
                          </span>
                        </div>
                      </div>
                    </a>
                    <a href="https://www.teleporthq.io">
                      <div className="navbar8-menu-item4">
                        <img
                          alt={t('navbar.dropdown.alt4')}
                          src="https://images.unsplash.com/photo-1509233725247-49e657c54213?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1NDIwMjk3N3w&ixlib=rb-4.1.0&q=80&w=1080"
                          className="navbar8-page4-image1"
                        />
                        <div className="navbar8-content4">
                          <span className="navbar8-page41 thq-body-large">
                            {t('navbar.dropdown.contact')}
                          </span>
                          <span className="thq-body-small">
                            {t('navbar.dropdown.contactDesc')}
                          </span>
                        </div>
                      </div>
                    </a>
                  </div>
                )}
              </div>
            </nav>
            <div className="navbar8-buttons2">
              <Link to="/booking">
                <button className="thq-button-filled">
                  <span className="navbar8-text22">{t('common.bookNow')}</span>
                </button>
              </Link>
              <button className="thq-button-outline">
                <span className="navbar8-text25">{t('common.contactUs')}</span>
              </button>
            </div>
          </div>
          <div className="navbar8-icon-group">
            <svg
              viewBox="0 0 950.8571428571428 1024"
              className="thq-icon-x-small"
            >
              <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
            </svg>
            <svg
              viewBox="0 0 877.7142857142857 1024"
              className="thq-icon-x-small"
            >
              <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
            </svg>
            <svg
              viewBox="0 0 602.2582857142856 1024"
              className="thq-icon-small"
            >
              <path d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"></path>
            </svg>
          </div>
        </div>
        {link5DropdownVisible === true && (
          <div className="navbar8-container7 thq-box-shadow">
            <div className="navbar8-link5-menu-list">
              <a href="https://www.teleporthq.io">
                <div className="navbar8-menu-item5">
                  <img
                    alt={t('navbar.dropdown.alt1')}
                    src="https://images.unsplash.com/photo-1611675822385-ef5f3fd290d7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1NDIwMjk3N3w&ixlib=rb-4.1.0&q=80&w=1080"
                    className="navbar8-page1-image2 thq-img-ratio-1-1"
                  />
                  <div className="navbar8-content5">
                    <span className="navbar8-page12 thq-body-large">
                      {t('navbar.dropdown.home')}
                    </span>
                    <span className="thq-body-small">
                      {t('navbar.dropdown.homeDesc')}
                    </span>
                  </div>
                </div>
              </a>
              <a href="https://www.teleporthq.io">
                <div className="navbar8-menu-item6">
                  <img
                    alt={t('navbar.dropdown.alt2')}
                    src="https://images.unsplash.com/photo-1586093698343-7941a6cfe354?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1NDIwMjk3N3w&ixlib=rb-4.1.0&q=80&w=1080"
                    className="navbar8-page2-image2 thq-img-ratio-1-1"
                  />
                  <div className="navbar8-content6">
                    <span className="navbar8-page22 thq-body-large">
                      {t('navbar.dropdown.about')}
                    </span>
                    <span className="thq-body-small">
                      {t('navbar.dropdown.aboutDesc')}
                    </span>
                  </div>
                </div>
              </a>
              <a href="https://www.teleporthq.io">
                <div className="navbar8-menu-item7">
                  <img
                    alt={t('navbar.dropdown.alt3')}
                    src="https://images.unsplash.com/photo-1487148742994-2f29d489182f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1NDIwMjk3OHw&ixlib=rb-4.1.0&q=80&w=1080"
                    className="navbar8-page3-image2 thq-img-ratio-1-1"
                  />
                  <div className="navbar8-content7">
                    <span className="navbar8-page32 thq-body-large">
                      {t('navbar.dropdown.location')}
                    </span>
                    <span className="thq-body-small">
                      {t('navbar.dropdown.locationDesc')}
                    </span>
                  </div>
                </div>
              </a>
              <a href="https://www.teleporthq.io">
                <div className="navbar8-menu-item8">
                  <img
                    alt={t('navbar.dropdown.alt4')}
                    src="https://images.unsplash.com/photo-1509233725247-49e657c54213?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1NDIwMjk3N3w&ixlib=rb-4.1.0&q=80&w=1080"
                    className="navbar8-page4-image2 thq-img-ratio-1-1"
                  />
                  <div className="navbar8-content8">
                    <span className="navbar8-page42 thq-body-large">
                      {t('navbar.dropdown.contact')}
                    </span>
                    <span className="thq-body-small">
                      {t('navbar.dropdown.contactDesc')}
                    </span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        )}
      </header>
      {link5DropdownVisible === true && (
        <div
          onClick={() => setLink5DropdownVisible(false)}
          className="navbar8-container8"
        ></div>
      )}
    </header>
  )
}

export default Navbar
